import { render } from "./GridParametriAplicatie.vue?vue&type=template&id=3b1a812b&scoped=true&ts=true"
import script from "./GridParametriAplicatie.vue?vue&type=script&lang=ts"
export * from "./GridParametriAplicatie.vue?vue&type=script&lang=ts"

import "./GridParametriAplicatie.vue?vue&type=style&index=0&id=3b1a812b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1a812b"]])

export default __exports__